export const life = [
    {
        id: "id_1",
        heading: "Diversity, Equality & Inclusion",
        text: "Now & Forever is the global leader in convenience, with a rich history and even brighter future. We understand that our people drive our success, —"
    },
    {
        id: "id_2",
        heading: "College Graduates",
        text: "Now & Forever is the global leader in convenience, with a rich history and even brighter future. We understand that our people drive our success, —"
    },
    {
        id: "id_3",
        heading: "Military Veterans",
        text: "Now & Forever is the global leader in convenience, with a rich history and even brighter future. We understand that our people drive our success, —"
    },
];